import React, { useState, useEffect, useContext } from "react";
import Headers from "../components/Headers";
import Footer from "../components/Footer";
import { Link, useNavigate } from "react-router-dom";
import FadeLoader from "react-spinners/FadeLoader";
import { useSelector, useDispatch } from "react-redux";
import { customer_login, messageClear } from "../store/reducers/authReducer";
import toast from "react-hot-toast";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { LanguageContext } from "../context/LanguageContext";

const Login = () => {
  const { loader, successMessage, errorMessage, userInfo } = useSelector(
    (state) => state.auth
  );
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useContext(LanguageContext);

  const [state, setState] = useState({ email: "", password: "" });
  const [showPassword, setShowPassword] = useState(false);

  const inputHandle = (e) => {
    setState({ ...state, [e.target.name]: e.target.value });
  };

  const login = (e) => {
    e.preventDefault();
    dispatch(customer_login(state));
  };

  useEffect(() => {
    if (successMessage) {
      toast.success(successMessage);
      dispatch(messageClear());
    }
    if (errorMessage) {
      toast.error(errorMessage);
      dispatch(messageClear());
    }
    if (userInfo) {
      navigate("/");
    }
  }, [successMessage, errorMessage, userInfo]);

  return (
    <div>
      {loader && (
        <div className="fixed inset-0 z-[999] bg-[#38303033] flex items-center justify-center">
          <FadeLoader />
        </div>
      )}
      <Headers />
      <div className="bg-slate-200 mt-4">
        <div className="max-w-[1440px] mx-auto px-6 py-10">
          <div className="bg-white shadow-md rounded-lg grid grid-cols-2 sm:grid-cols-1 mx-auto w-[60%] md:w-full">
            <div className="p-8">
              {/* Progress Indicator (Optional) */}
              <div className="flex items-center justify-center mb-6">
                <div className="w-6 h-6 rounded-full bg-purple-500"></div>
              </div>

              {/* Login Form */}
              <h2 className="text-xl font-bold text-center text-slate-600 mb-6">
                {t("login")}
              </h2>
              <form onSubmit={login} className="text-slate-600">
                <div className="mb-4">
                  <label htmlFor="email">{t("emailLabel")}</label>
                  <input
                    onChange={inputHandle}
                    value={state.email}
                    type="email"
                    name="email"
                    id="email"
                    placeholder={t("emailPlaceholder")}
                    className="w-full mt-1 px-3 py-2 border border-slate-200 rounded-md outline-none focus:border-purple-500"
                    required
                  />
                </div>
                <div className="mb-4">
                  <label htmlFor="password">{t("passwordLabel")}</label>
                  <div className="relative flex items-center">
                    <input
                      onChange={inputHandle}
                      value={state.password}
                      type={showPassword ? "text" : "password"}
                      name="password"
                      id="password"
                      placeholder={t("passwordPlaceholder")}
                      className="w-full px-3 py-2 border border-slate-200 rounded-md pr-10 outline-none"
                      required
                    />
                    <span
                      className="absolute right-3 cursor-pointer text-gray-500"
                      onClick={() => setShowPassword(!showPassword)}
                    >
                      {showPassword ? <FaEyeSlash /> : <FaEye />}
                    </span>
                  </div>
                  {/* Forgot Password Link */}
                  <div className="text-right mt-1">
                    <Link
                      to="/forgot-password"
                      className="text-sm text-purple-500 hover:underline"
                    >
                      {t("forgotPassword")}
                    </Link>
                  </div>
                </div>
                <button
                  type="submit"
                  className="w-full py-2 bg-purple-500 text-white rounded-md hover:bg-purple-600 transition"
                  disabled={loader}
                >
                  {loader ? t("loggingIn") : t("login")}
                </button>
              </form>

              <p className="mt-4 text-center text-sm text-slate-500">
                {t("dontHaveAccount")}{" "}
                <Link className="text-blue-500" to="/register">
                  {t("register")}
                </Link>
              </p>
            </div>

            {/* Right Image */}
            <img
              className="w-full h-[95%]"
              src="/images/login.jpg"
              alt="Login"
            />

            {/* Right Image (Mobile) */}
            <div className="hidden md:block w-[40%]">
              <img
                src="/images/login.jpg"
                alt="Login"
                className="w-full h-full object-cover rounded-r-lg"
              />
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Login;
